import { render, staticRenderFns } from "./newViewDetail.vue?vue&type=template&id=38612b20"
import script from "./newViewDetail.vue?vue&type=script&lang=js"
export * from "./newViewDetail.vue?vue&type=script&lang=js"
import style0 from "./newViewDetail.vue?vue&type=style&index=0&id=38612b20&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/重构-快递前端-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('38612b20')) {
      api.createRecord('38612b20', component.options)
    } else {
      api.reload('38612b20', component.options)
    }
    module.hot.accept("./newViewDetail.vue?vue&type=template&id=38612b20", function () {
      api.rerender('38612b20', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/invoiceCenter/customerInvoiceSubjectConfiguration/cmp/newViewDetail.vue"
export default component.exports